import { jsx as _jsx } from "react/jsx-runtime";
import { Geofence } from '@iotv/datamodel';
import { useMemo } from 'react';
import { RulesetGeofenceRuleCard } from '../../Notification/Rulesets/GeofenceRuleCard';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const RulesetGeofenceRuleCardWidget = () => {
    const component = useMemo(() => (_jsx(RulesetGeofenceRuleCard, { geofenceRule: new Geofence({ name: 'Geofence', enabled: true }), geofences: [], setGeofenceRule: (geofenceRule) => {
            // set this geofence rule in the parent ruleset here
        }, removeArrayObjectNInParent: () => {
            // remove this geofence rule from the parent ruleset here
        } })), []);
    return {
        name: 'RulesetGeofenceRuleCard',
        category: 'common',
        component,
    };
};
